import useShipmentFetch from "./useShipmentFetch"

export default () => {
  const { shipmentFetch, isLoading } = useShipmentFetch()

  return {
    fetchProducts: async () => {
      return await shipmentFetch(`shipping/product`)
    },
    isProductsLoading: isLoading
  }
}